module.exports = __webpack_public_path__ + "img/brands-union.809f9399.png";